import { createContext } from 'react';
import { CreatePaymentRequest } from 'types';

export interface IRequestPaymentsContext {
  requestPaymentFromClient(payload: CreatePaymentRequest): Promise<void>;
}

export const RequestPaymentsContext = createContext<IRequestPaymentsContext | null>(null);
export const RequestPaymentsConsumer = RequestPaymentsContext.Consumer;
